__turbopack_context__.v({
  "action": "-QjKfa_action",
  "description": "-QjKfa_description",
  "icon": "-QjKfa_icon",
  "root": "-QjKfa_root",
  "title": "-QjKfa_title",
});
